import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';

export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${config.apiUrl}/products`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.user?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProductsCatalogBrowse: builder.query({
      query: ({ parentId, search } = {}) => ({
        url: '/catalog',
        params: { parentId, search },
      }),
    }),
  }),
});

export const { useGetProductsCatalogBrowseQuery } = productsApi;
